import { NgModule } from '@angular/core';

import { LocationNamePipe } from './location-name.pipe';

@NgModule({
  declarations: [LocationNamePipe],
  exports: [LocationNamePipe],
})
export class LocationsPipeModule {}
